import { PageHeader, Section } from "@/components/site/PageChrome";
import { Trash2, Smartphone, Mail, AlertTriangle, Clock } from "lucide-react";

export default function AccountDeletionPage() {
  const steps = [
  {
    icon: Mail,
    t: "Request Account Deletion",
    d: "To permanently delete your Time2Cash account, send an email to hello@time2cash.co from your registered email address. Include your registered mobile number and use the subject 'Account Deletion Request' for faster processing.",
  },
  {
    icon: AlertTriangle,
    t: "Need Help Before Deleting?",
    d: "Have questions about deleting your account or the data associated with it? Contact our support team via hello@time2cash.co or through our official WhatsApp Support. We'll explain the process, answer your questions, and guide you before you submit your deletion request.",
  },
];

  const afterwards = [
  "Your Time2Cash account will be permanently deleted after successful verification.",
  "Your profile information and account data will no longer be accessible.",
  "Any unused wallet credits, subscriptions or promotional benefits will be forfeited and cannot be refunded.",
  "Some information may be retained where required by applicable law, fraud prevention, dispute resolution or regulatory compliance.",
  "Once the deletion process is completed, your account and associated data cannot be recovered.",
];
  return (
    <>
      <PageHeader
  eyebrow="Account Deletion"
  title="Delete your account."
  subtitle="If you wish to permanently delete your Time2Cash account, simply send us an email. Our support team will verify your request and securely process your account deletion request."
/>
      <Section>
        <div className="max-w-3xl mx-auto">
          <div className="grid md:grid-cols-2 gap-6">
            {steps.map(({ icon: Icon, t, d }) => (
              <div key={t} className="rounded-3xl border border-[#EBE8E3] bg-white p-7">
                <div className="w-12 h-12 rounded-2xl bg-[#FFF3ED] flex items-center justify-center">
                  <Icon className="w-6 h-6 text-[#FF5A00]" />
                </div>
                <h3 className="mt-4 text-lg font-bold text-[#1A1918]">{t}</h3>
                <p className="mt-2 text-sm text-[#4A4846] leading-relaxed">{d}</p>
              </div>
            ))}
          </div>

          <div className="mt-8 rounded-3xl border border-red-100 bg-red-50 p-7">
            <div className="flex items-center gap-2 text-red-600 font-bold">
              <AlertTriangle className="w-5 h-5" /> What happens after deletion
            </div>
            <ul className="mt-4 space-y-2">
              {afterwards.map((a) => (
                <li key={a} className="flex gap-2 text-[#4A4846] text-sm">
                  <Trash2 className="w-4 h-4 text-red-500 mt-0.5 flex-shrink-0" /> {a}
                </li>
              ))}
            </ul>
          </div>

          <div className="mt-8 rounded-3xl border border-[#EBE8E3] bg-white p-7 flex items-start gap-3">
  <Clock className="w-5 h-5 text-[#FF5A00] mt-0.5" />

  <p className="text-sm text-[#4A4846] leading-relaxed">
    Account deletion requests are generally processed within <strong>7 working days</strong> after successful verification.
    If you have any questions regarding account deletion or require assistance, please contact our support team at {" "}
    <a
      href="mailto:hello@time2cash.co"
      className="font-semibold text-[#FF5A00]"
    >
       hello@time2cash.co
    </a> {" "}
    or reach out to us through our official WhatsApp Support available on the Contact page. Our team will be happy to assist you throughout the account deletion process.
  </p>
</div>
        </div>
      </Section>
    </>
  );
}
